import React from 'react';
import Draggable from 'react-draggable';

const DraggableContainer = ({ title, children, handleClose = () => {} }) => {
  return (
    <Draggable handle=".handle">
      <div
        style={{
          width: 'auto',
          minWidth: '540px',
          maxWidth: '60%',
          height: 'auto',
          border: '1px solid #666666',
          position: 'fixed',
          right: 0,
          top: 80,
          overflow: 'scroll',
          background: 'white',
        }}
      >
        <div
          className="handle"
          style={{
            backgroundColor: '#0dcaf0',
            padding: 10,
            cursor: 'move',
            color: 'white',
          }}
        >
          {title || "I'm Draggable"}
          <button
            onClick={() => {
              console.log('close draggable');
              console.log('handleClose, ', handleClose);
              typeof handleClose === 'function' && handleClose();
            }}
            style={{ position: 'absolute', top: 5, right: 5, cursor: 'pointer' }}
          >
            X
          </button>
        </div>
        <div style={{ padding: 10 }}>{children}</div>
      </div>
    </Draggable>
  );
};

export default DraggableContainer;
